import { Navbar, NavbarItem } from '@typedream/core';
import styled from 'styled-components';
import { findNodePath } from '@udecode/plate-core';
import { useContext } from 'react';
import { AddMenuButtonEditor } from './NavbarMenuAddButton';
import { NavbarMenuItemElementEditor } from './NavbarMenuItemElement';
import { useTPlateEditorRef } from '../../../plate';
import { NavbarMenuItemContext } from '../context/navbar.context';

type MenuType = 'middle' | 'end';

const size = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  laptop: '1024px',
  laptopL: '1440px',
  desktop: '2560px',
};

export const device = {
  mobileS: `(min-width: ${size.mobileS})`,
  mobileM: `(min-width: ${size.mobileM})`,
  mobileL: `(min-width: ${size.mobileL})`,
  tablet: `(min-width: ${size.tablet})`,
  laptop: `(min-width: ${size.laptop})`,
  laptopL: `(min-width: ${size.laptopL})`,
  desktop: `(min-width: ${size.desktop})`,
  desktopL: `(min-width: ${size.desktop})`,
};

function computeMenuContainerAlignment(params: {
  alignment: Navbar['alignment'],
  type: MenuType,
}) {
  if (params.type === 'end') {
    return 'flex-end';
  }

  switch (params.alignment) {
    case 'center':
      return 'center';

    case 'end':
      return 'flex-end';

    case 'start':
    default:
      return 'flex-start';
  }
}
const StyledDivContainer = styled.div<{
  isActive: boolean,
  type: MenuType,
  justifyContent: Navbar['alignment'],
}>`
  padding: 0 0.25rem;
  display: ${(props) => (props.isActive ? 'block' : 'none')};
  padding-top: ${(props) => (props.type === 'middle' ? '0.5rem' : '0')};
  padding-bottom: ${(props) => (props.type === 'end' ? '0.5rem' : '0')};
  /* clip-path: ${(props) => (props.type === 'middle' ? 'inset(-8px 0px 0px 0px)' : 'inset(0px 0px -24px 0px)')}; */
  align-items: stretch;

  @media only screen and (min-width: 1024px) { 
    display: flex;
    align-items: stretch;
    padding-top: 0;
    padding-bottom: 0;
    justify-content: ${(props) => computeMenuContainerAlignment({ alignment: props.justifyContent, type: props.type })};
  }
`;

export function MenuContainerElementEditor(props: {
  type: MenuType,
}) {
  const { type } = props;
  const { element: navbar } = useContext(NavbarMenuItemContext);
  const editor = useTPlateEditorRef();
  const onClickMenuItem = (index: number, isEndMenu: boolean, ref: HTMLElement | null) => {
    const navbarPath = findNodePath(editor, navbar)!;
    editor.emitter.emit(
      'toolbar:navbar:setting-menu:toggle',
      {
        navbarPath, type: isEndMenu ? 'endMenu' : 'menu', index, ref,
      },
    );
  };

  const createMenuItems = (items: NavbarItem[], endMenu?: boolean) => items.map((item, index) => (
    <NavbarMenuItemElementEditor
      // eslint-disable-next-line react/no-array-index-key
      key={index}
      item={item}
      index={index}
      endMenu={endMenu}
      onClick={(ref) => onClickMenuItem(index, type === 'end', ref)}
    />
  ));

  const menuItems = type === 'middle' ? createMenuItems(navbar.menu) : createMenuItems(navbar.endMenu, true);

  return (
    <StyledDivContainer
      type={type}
      // TODO: Add burger state here
      isActive={false}
      justifyContent={navbar?.alignment}
    >
      {type === 'end'
        && (
          <AddMenuButtonEditor
            handler={
              () => editor.emitter.emit('toolbar:add-navbar-endmenu-item')
            }
          />
        )}
      {menuItems}
      {type === 'middle'
        && (
          <AddMenuButtonEditor
            handler={() => editor.emitter.emit('toolbar:add-navbar-menu-item')}
          />
        )}
    </StyledDivContainer>
  );
}
